import { useGetEntity } from '@abaninja/util-store';

import { getPayments } from '../documents';

export const useDocumentPaymentsStore = () => useGetEntity(getPayments);
